const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousehold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "585.225px",
    height: "585.225px",
    viewBox: "0 0 585.225 585.225",
    style: {
      enableBackground: "new 0 0 585.225 585.225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_134_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M489.6,36.975c-44.625,0-81.6,30.6-90.525,71.4H183.6c-10.2-40.8-47.175-71.4-90.525-71.4 C42.075,36.975,0,79.049,0,130.049c0,35.7,20.4,67.575,51,82.875V313.65c0,130.049,112.2,234.6,242.25,234.6 c130.051,0,242.25-104.551,242.25-234.6V212.924c29.324-15.3,49.725-47.175,49.725-82.875 C583.949,79.049,541.875,36.975,489.6,36.975z M169.575,229.5c0-14.025,11.475-26.775,26.775-26.775s26.775,11.475,26.775,26.775 s-11.475,26.775-26.775,26.775S169.575,244.799,169.575,229.5z M290.7,502.35c-48.45,0-89.25-52.275-89.25-116.025 s39.525-116.025,89.25-116.025c49.726,0,89.249,52.275,89.249,116.025S340.426,502.35,290.7,502.35z M386.324,256.274 c-15.299,0-26.773-11.475-26.773-26.775c0-14.025,11.475-26.775,26.773-26.775c14.025,0,26.775,11.475,26.775,26.775 S401.625,256.274,386.324,256.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M244.8,337.875c-7.65,0-15.3,3.824-17.85,10.199c-2.55,7.65-1.275,15.301,3.825,20.4l45.9,45.9 c7.65,7.65,20.399,7.65,28.049,0l45.9-45.9c5.1-5.1,7.65-12.75,3.824-20.4c-2.549-7.65-10.199-10.199-17.85-10.199H244.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousehold);
export default __webpack_public_path__ + "static/media/household.3d475eccda40223350216f1d36403e51.svg";
export { ForwardRef as ReactComponent };